import { MeetingStatus } from 'components/features/coaching/advisorPage/types/interfaces'

export const TRUNCATED_BIO_LENGTH = 150 // characters

export const DEFAULT_MEETING_DURATION = 30 // minutes

export const SEARCH_ADVISOR_DURATION = 3600

export const MEETING_STATUS_MAP: Record<MeetingStatus, string> = {
  scheduled: 'Scheduled',
  cancelled: 'Canceled',
  missed: 'Not Attended',
  completed: 'Completed',
}
